// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint[data-v-17d75299]{font-size:11px;line-height:1.2;margin-top:8px}", ""]);
// Exports
module.exports = exports;
